module.exports = __webpack_public_path__ + "img/cns_printer_mac20.3ae824b1.png";